import { render, staticRenderFns } from "./CustomerOrderDetails.vue?vue&type=template&id=4d49026c&scoped=true"
import script from "./CustomerOrderDetails.vue?vue&type=script&lang=js"
export * from "./CustomerOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderDetails.vue?vue&type=style&index=0&id=4d49026c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d49026c",
  null
  
)

export default component.exports